<template>
    <div>
        <NewAnimalMedicationForm ref="newMedicationForm" :animalId="animalId" :warehouseId="warehouseId"
            v-if="isNewMedication" @close="isNewMedication = false" @medication-added="fetchMedications" />
        <div class="recent-activity p-4 pb-0">
            <div class="mb-4 pb-2 d-flex justify-content-between">
                <h5 class="fw-bold">Yapılan Tedaviler:</h5>
                <button @click="newMedication()" v-if="!isNewMedication" class="btn btn-sm btn-light-brand">
                    Yeni Tedavi
                </button>
            </div>
            <ul class="list-unstyled activity-feed" v-for="medication in medications">
                <li class="d-flex align-items-start feed-item feed-item-success" style="padding-bottom: 0;">
                    <div style="flex: 1;">
                        <span class="text">{{ formatDate(medication.medication_date) }}<br>
                            <a class="fw-bold text-primary">{{ medication.name }}</a>
                        </span>
                        <span class="text-truncate-1-line lead_date">
                            {{ medication.description }}
                        </span>
                    </div>
                    <div class="me-3" v-if="medication.medication_prescription.length > 0">
                        <span class="text d-block mb-1">REÇETE</span>
                        <table class="table table-sm mb-0" style="border: thin solid #ccc;">
                            <thead>
                                <tr>
                                    <th>İLAÇ</th>
                                    <th>MİKTAR (Doz)</th>
                                    <th>PERİYOD (Saat)</th>
                                    <th>SÜRE (Gün)</th>
                                    <th>AÇIKLAMA</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="prescription in medication.medication_prescription">
                                    <td>{{ prescription.medicine_name }}</td>
                                    <td>{{ prescription.quantity }}</td>
                                    <td>{{ prescription.period }}</td>
                                    <td>{{ prescription.duration }}</td>
                                    <td>{{ prescription.description }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="d-flex gap-2 align-items-center">
                        <button @click="newMedicationDetailF(medication.id)" title="Tedaviye Devam Et"
                            class="avatar-text avatar-sm bg-success">
                            <i class="feather feather-file-plus fs-12"></i>
                        </button>
                        <button @click="deleteMedication(medication.id)" title="Kaydı Sil"
                            class="avatar-text avatar-sm bg-danger">
                            <i class="feather feather-trash-2 fs-12"></i>
                        </button>
                    </div>
                </li>

                <div class="d-flex  justify-content-end">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>İlaç</th>
                                <th>Miktar</th>
                                <th>SKT</th>
                                <th>Açıklama</th>
                                <th>Tarih</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="medicationDetail in medication.medication_detail">
                                <td>{{ medicationDetail.medicine_name }}</td>
                                <td class="text-end col-1">{{ medicationDetail.quantity }}</td>
                                <td>{{ formatDate(medicationDetail.expiration_date) }}</td>
                                <td>{{ medicationDetail.description }}</td>
                                <td>{{ formatDate(medicationDetail.created_at) }}</td>
                            </tr>
                        </tbody>
                        <tfoot v-if="selectedMedicationId === medication.id">
                            <tr>
                                <td>
                                    <select v-model="newMedicationDetail.medicine" class="form-select form-select-sm">
                                        <option v-for="medicine in medicines" :key="medicine.medicine_id"
                                            :value="medicine.medicine_id">
                                            {{ String(medicine.quantity).padStart(4, '0') }} Ad. {{
                                                medicine.medicine_name
                                            }}
                                        </option>
                                    </select>
                                </td>
                                <td><input type="number" v-model="newMedicationDetail.quantity"
                                        class="form-control form-control-sm no-spinner"></td>
                                <td>
                                    <select v-model="newMedicationDetail.expiration_date"
                                        class="form-select form-select-sm">
                                        <option v-for="date in medicineExpirationDates" :key="date" :value="date">
                                            {{ date }}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <input type="text" name="description" v-model="newMedicationDetail.description"
                                        class="form-control form-control-sm">
                                </td>
                                <td>
                                    <div class="d-flex gap-2 align-items-center justify-content-end">
                                        <button @click="postMedicationDetail()"
                                            class="avatar-text avatar-sm bg-success">
                                            <i class="feather feather-check-circle fs-12"></i>
                                        </button>
                                        <button @click="selectedMedicationId = null"
                                            class="avatar-text avatar-sm bg-warning">
                                            <i class="feather feather-x-circle fs-12"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </ul>
        </div>
    </div>
</template>
<script>
import NewAnimalMedicationForm from '@/components/animal/NewAnimalMedicationForm.vue';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
export default {
    name: 'AnimalMedication',
    components: {
        NewAnimalMedicationForm,
    },
    props: {
        animalId: {
            type: Number,
            required: true,
        },
        shelterId: {
            type: Number,
            required: false,
        },
        warehouseId: {
            type: Number,
            required: false,
        },
    },
    data() {
        return {
            medicineExpirationDates: [],
            medications: [],
            medicines: [],
            isNewMedication: false,
            newMedicationDetail: {
                medication: 0,
                medicine: 0,
                expiration_date: '',
                quantity: 0,
                description: '',
            },
            selectedMedicationId: null,
            animalDetails: null,
        }
    },
    computed: {
        filteredExpirationDates() {
            return this.medicines
                .filter(med => med.medicine_id === this.newMedicationDetail.medicine)
                .map(med => med.expiration_date);
        }
    },
    watch: {
        'newMedicationDetail.medicine'(newMedicineId) {
            if (newMedicineId) {
                console.log('çağrı tetiklendi.', newMedicineId);
                this.$axios.get(`warehouse-stock-by-expiration/?warehouse_id=${this.warehouseId}`)
                    .then(response => {
                        this.medicineExpirationDates = response.data.filter(med => med.medicine_id === newMedicineId && med.quantity > 0).map(med => med.expiration_date);
                    })
                    .catch(error => {
                        console.error("Hata:", error);
                        this.medicineExpirationDates = [];
                    });
            } else {
                this.medicineExpirationDates = [];
            }
        }
    },
    methods: {
        async postMedicationDetail() {
            try {
                this.newMedicationDetail.medication = this.selectedMedicationId;
                console.log('newMedicationDetail', this.newMedicationDetail);
                this.$axios.post('medication_detail/', this.newMedicationDetail);
                this.newMedicationDetail = {
                    medication: 0,
                    medicine: 0,
                    expiration_date: '',
                    quantity: 0,
                    description: '',
                };
                this.selectedMedicationId = null;
                this.fetchMedications();
            } catch (error) {
                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage, // HTML olarak göster (Satır atlamaları çalışsın)
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },
        async newMedicationDetailF(medicationId) {
            this.selectedMedicationId = medicationId;
            this.newMedicationDetail.medication = medicationId;
            await this.fetchMedicines();
        },
        newMedication() {
            this.isNewMedication = true;
            this.fetchMedicines();
            console.log('isNewMedication Çalıştı.');
        },
        async fetchMedicines() {
            console.log(this.warehouseId);
            try {
                const response = await this.$axios.get(`warehouse-stock/?warehouse_id=${this.warehouseId}`);
                this.medicines = response.data;
            } catch (error) {
                console.error(error);
            }
            console.log('medicines çalıştı', this.medicines);
        },
        async fetchMedications() {
            this.isNewMedication = false;
            try {
                console.log('medication çalıştı');
                const medics = await this.$axios.get(`medication/?animal=${this.animalId}`);
                this.medications = medics.data.results;
                console.log(this.medications);
            } catch (error) {
                console.error(error);
                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },

        async deleteMedication(id) {
            try {
                const result = await Swal.fire({
                    title: "Silmek istediğinizden emin misiniz?",
                    text: "Bu işlem geri alınamaz!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Evet, sil!",
                    cancelButtonText: "Hayır, iptal et"
                });

                if (result.isConfirmed) {
                    this.$axios.delete(`medication/${id}/`);
                    this.medications = this.medications.filter((medication) => medication.id !== id);
                }
            } catch (error) {
                console.log(error);
                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage, // HTML olarak göster (Satır atlamaları çalışsın)
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },
        formatDate(date) {
            if (!date) {
                return '';
            }
            return dayjs(date).format('DD.MM.YYYY');
        }
    },
}
</script>
<style>
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.no-spinner {
    -moz-appearance: textfield;
    text-align: right;
}
</style>